// extracted by mini-css-extract-plugin
module.exports = {"case_template_title":"TemplatePopup_case_template_title__1hGxk"};